// Logo APP PRESSE + signature "Le monde s'ouvre à vous" (utilisé partout où le logo apparaît).
export const Wordmark = ({ imgClass = "h-8 w-auto", taglineClass = "text-[11px] sm:text-xs", tagline = true }) => (
  <span className="inline-flex flex-col items-center leading-none" data-testid="app-wordmark">
    <img src="/logo.png" alt="APP PRESSE" className={`${imgClass} dark:hidden`} />
    <span className="hidden dark:inline font-serif text-2xl">
      <span className="font-black text-white">APP</span> <span className="font-semibold text-primary">PRESSE</span>
    </span>
    {tagline && (
      <span className={`font-serif font-medium text-primary/85 mt-0.5 ${taglineClass}`}>Le monde s'ouvre à vous</span>
    )}
  </span>
);
